import {
    activityRecordTypeForGoalMetricItemLinkKind,
    GoalMetricItemLink,
} from "@sp-crm/core";
import { hrefForActivityRecord } from "util/activity-record-href";

export const goalMetricItemHref = (link: GoalMetricItemLink): string =>
    hrefForActivityRecord(
        activityRecordTypeForGoalMetricItemLinkKind[link.kind],
        link.entityId,
    );

export const formatGoalMetricItemDate = (date: string): string =>
    new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        timeZone: "UTC",
    });
